/* eslint-disable no-unused-vars */
import API from 'utils/api';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = '/nominas/citas';
export const baseURI2 = '/nominas/historico-citas';

/**
 * GET citas
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getCitas = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * POST Cita
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postCita = async (values) => {
  try {
    // eslint-disable-next-line no-param-reassign
    values.clave = '1';
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Cita
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchCita = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Cita
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteCita = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET citas
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getCitasHistoricos = async (params) => {
  try {
    const response = await API.get(baseURI2, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET citas
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getCitasHistorico = async (id) => {
  try {
    const response = await API.get(`${baseURI2}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};
